<template>
  <div class="container mt-5 pb-5">
    <h1 class="mb-2">Create Course</h1>
    <form @submit.prevent="handleSubmit">
      <div class="form-group">
        <label for="course-name">Course Name:</label>
        <input
          v-model="courseName"
          type="text"
          class="form-control"
          id="course-name"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="course-description">Course Description:</label>
        <input
          v-model="courseDescription"
          type="text"
          class="form-control"
          id="course-description"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="course-category">Course Category:</label>
        <select
          v-model="courseCategory"
          class="form-control"
          id="course-category"
        >
          <option value="Animation">Animation</option>
          <option value="Creative Writing">Creative Writing</option>
          <option value="Film &amp; Video">Film &amp; Video</option>
          <option value="Fine Art">Fine Art</option>
          <option value="Graphic Design">Graphic Design</option>
          <option value="Illustration">Illustration</option>
          <option value="Music">Music</option>
          <option value="Photography">Photography</option>
          <option value="UI/UX Design">UI/UX Design</option>
          <option value="Web Development">Web Development</option>
          <option value="Business Analytics">Business Analytics</option>
          <option value="Freelance &amp; Entrepreneurship"
            >Freelance &amp; Entrepreneurship</option
          >
          <option value="Leadership &amp; Management"
            >Leadership &amp; Management</option
          >
          <option value="Marketing">Marketing</option>
          <option value="Lifestyle">Lifestyle</option>
          <option value="Productivity">Productivity</option>
        </select>
      </div>
      <div class="form-group">
        <label for="min-age">Minimum Age:</label>
        <input
          v-model="minimumAge"
          type="number"
          class="form-control"
          id="min-age"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="meeting-time-one">Meeting Time One:</label>
        <input
          v-model="meetingTimeOne"
          type="text"
          class="form-control"
          id="meeting-time-one"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="meeting-time-two">Meeting Time Two:</label>
        <input
          v-model="meetingTimeTwo"
          type="text"
          class="form-control"
          id="meeting-time-two"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="meeting-time-three">Meeting Time Three:</label>
        <input
          v-model="meetingTimeThree"
          type="text"
          class="form-control"
          id="meeting-time-three"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="meeting-link-one">Meeting Link One:</label>
        <input
          v-model="meetingLinkOne"
          type="text"
          class="form-control"
          id="meeting-link-one"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="meeting-link-two">Meeting Link Two:</label>
        <input
          v-model="meetingLinkTwo"
          type="text"
          class="form-control"
          id="meeting-link-two"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="creator-name">Creator Name:</label>
        <input
          v-model="creatorName"
          type="text"
          class="form-control"
          id="creator-name"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="form-group">
        <label for="creator-uid">Creator UID:</label>
        <input
          v-model="creatorUid"
          disabled="true"
          type="text"
          class="form-control"
          id="creator-uid"
          aria-describedby="emailHelp"
        />
      </div>
      <button type="submit" class="btn btn-primary">Submit</button>
    </form>
  </div>
</template>

<script>
import db from '@/components/firebaseInit'

export default {
  name: 'AddCourse',
  data() {
    return {
      courseName: '',
      courseDescription: '',
      courseCategory: 'Animation',
      minimumAge: 0,
      meetingTimeOne: '',
      meetingTimeTwo: '',
      meetingTimeThree: '',
      meetingLinkOne: 'https://zoom.us/',
      meetingLinkTwo: 'https://meet.google.com/',
      creatorName: '',
      creatorUid: ''
    }
  },
  created() {
    this.creatorUid = localStorage.getItem('uid')
  },
  methods: {
    handleSubmit() {
      db.collection('courses')
        .add({
          name: this.courseName,
          description: this.courseDescription,
          category: this.courseCategory,
          minAge: this.minimumAge,
          meetTimes: [
            this.meetingTimeOne,
            this.meetingTimeTwo,
            this.meetingTimeThree
          ],
          meetingLinks: [this.meetingLinkOne, this.meetingLinkTwo],
          creatorName: this.creatorName,
          creatorUid: this.creatorUid
        })
        .then(() => {
          this.$router.push('/')
        })
        .catch(err => {
          alert(err.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
